import React, { useContext, useEffect, useState } from "react";
import { GlobalInfo } from "../App";
export default function Completeinfo(props) {
  const { val, acc, getupdate } = useContext(GlobalInfo);
  const [clockState, setClockstate] = useState();
  setInterval(() => {
    var x = props.arr.deadline;
    const time = new Date(x * 1000);
    setClockstate(time.toLocaleDateString());
    // console.log(clockState);
  }, 1000);

  //  }

  const sendpayment = async () => {
    const { web3, contract } = val;
    await contract?.makePayment(props.arr.id, {
      from: acc,
    });
    getupdate();
  };

  const pay = async () => {
    const { web3, contract } = val;
    var a = document.getElementById("payamount").value;
    // const am=web3.utilsweb3.toWei("1", "ether");
    console.log(a);
    await contract.sendEth(props.arr.id, {
      from: acc,
      value: web3.utils.toWei(a, "ether"),
    });

    getupdate();
  };

  // var timestamp = parseInt(props.arr.deadline*1000);
  // var date = new Date(timestamp);
  // document.getElementById("dead").innerHTML={date};

  // setdats(date);
  // console.log(dats);
  // console.log("Date: "+ date.getDate()+
  //         "/"+(date.getMonth()+1)+
  //         "/"+date.getFullYear()+
  //         " "+date.getHours()+
  //         ":"+date.getMinutes()+
  //         ":"+date.getSeconds());

  return (
    <>
      <center>
        <h1>Category:-{props.arr.category}</h1>
        <h2>Description:-{props.arr.description}</h2>
        <h3>Target:-{props.arr.target}</h3>
        {/* {props.arr.deadline ? getdead() :clockState } */}
        <h4>Deadline:-{clockState}</h4>
        <h5>FundRaised:-{props.arr.raisedAmount}</h5>
        <h6>Receipient:-{props.arr.recipient}</h6>
        <h6>Approved Status:-{props.arr.approved ? "true" : "false"}</h6>
        <h6>Completed:-{props.arr.completed ? "true" : "false"}</h6>
        <h6>No of Donors:- {props.arr.noOfDonors}</h6>
        {/* <button onClick={()=>getdead()}>click me</button>  */}
        {<img src={props.arr.file_hash} width="400px" alt="get img" />}
        {props.arr.approved === true ? (
          <>
            <input id="payamount"></input>
            <button onClick={() => pay()}>Pay Now</button>
            <button onClick={() => sendpayment()}>transfer</button>
          </>
        ) : (
          <div></div>
        )}
      </center>
    </>
  );
}
